import ZoomModule from './zoom.module'
import GameManagerModule from './game.module'

export {
  ZoomModule,
  GameManagerModule
}
